import script from "./MenuAcoesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuAcoesView.vue?vue&type=script&setup=true&lang=js"

import "./MenuAcoesView.vue?vue&type=style&index=0&id=3ef51ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef51ab2"]])

export default __exports__